export const FULLSCREEN_IFRAME_CSS = `
.fullscreen-iframe {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 999999999999 !important;
  background: white !important;
}

.full-screen-iframe-body {
  overflow: hidden !important;
}

@keyframes shrinkAndFade {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}

.shrink-fade-out {
  animation: shrinkAndFade 0.5s forwards;
}

@keyframes expandAndFadeIn {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.expand-fade-in {
  animation: expandAndFadeIn 0.5s forwards;
}
`;